// extracted by mini-css-extract-plugin
export default {"condition":"crn1LzFWrmph7cxnRPV04Q==","termsAndConditionsLink":"LvTiRA-kMxSSGNkavkNa5A=="};